import styled from 'styled-components';
import { blurBox, timeDescription } from 'styles/parcelSharedStyles';
import Typography from '../Typography';

export const Container = styled.div`
  margin-bottom: ${({ shouldRemoveSectionGap }) =>
    shouldRemoveSectionGap ? '0px' : '8px'};
`;

export const MainBox = styled.div`
  ${blurBox}
`;

export const Description = styled.div`
  ${timeDescription}
`;

export const Title = styled(Typography).attrs({
  level: 'displayMd',
})`
  text-transform: capitalize;
`;
